import React from "react";
import { useUpdate, useNotify, Button } from "react-admin";

import DisabledIcon from "@material-ui/icons/PersonAddDisabled";
import EnabledIcon from "@material-ui/icons/HowToReg";

import { UserStatus } from "../../../utils/constants";

export const UserSuspendButton = ({ record, ...props }) => {
  const notify = useNotify();
  debugger;

  const input = {
    id: record.id,
    status:
      record.status === UserStatus.SUSPENDED
        ? UserStatus.APPROVED
        : UserStatus.SUSPENDED,
  };
  const [update, { loading, error }] = useUpdate(
    "users",
    record.id,
    input,
    record,
    {
      undoable: false,
      onSuccess: () => {
        notify("User Status updated.");
      },
      onFailure: () => {
        console.error("User status update failed:", error);
        notify("Access update failed.", "error");
      },
    }
  );

  return (
    <Button
      label={
        record.status === UserStatus.SUSPENDED
          ? "Enable Access"
          : "Suspend Access"
      }
      style={{ marginLeft: "1em" }}
      disabled={loading}
      onClick={update}
    >
      {record.status === UserStatus.SUSPENDED ? (
        <EnabledIcon />
      ) : (
        <DisabledIcon />
      )}
    </Button>
  );
};
